import { LegalEntityStatus, LegalForm } from '@shared/api/graphql/gql/graphql';

/** Зеркало backend `App\Support\Legal\RussianRequisites`: алгоритмы и веса совпадают. */

const TIN10_WEIGHTS = [2, 4, 10, 3, 5, 9, 4, 6, 8];
const TIN12_FIRST_WEIGHTS = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8];
const TIN12_SECOND_WEIGHTS = [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8];

function tinCheckDigit(value: string, weights: number[]): number {
  const sum = weights.reduce((total, weight, index) => total + Number(value[index]) * weight, 0);
  return (sum % 11) % 10;
}

export function isTin(value: string): boolean {
  if (/^\d{10}$/.test(value)) return tinCheckDigit(value, TIN10_WEIGHTS) === Number(value[9]);
  if (/^\d{12}$/.test(value)) {
    return (
      tinCheckDigit(value, TIN12_FIRST_WEIGHTS) === Number(value[10]) &&
      tinCheckDigit(value, TIN12_SECOND_WEIGHTS) === Number(value[11])
    );
  }
  return false;
}

export function isTinFor(form: LegalForm, value: string): boolean {
  return value.length === (form === LegalForm.Organization ? 10 : 12) && isTin(value);
}

export function isKpp(value: string): boolean {
  return /^\d{4}[\dA-Z]{2}\d{3}$/.test(value);
}

export function legalFormLabel(form: LegalForm): string {
  return form === LegalForm.Organization ? 'ООО' : 'ИП';
}

/** Вкладки «ООО / ИП» в формах реквизитов. */
export const LEGAL_FORM_OPTIONS = [LegalForm.Organization, LegalForm.IndividualEntrepreneur].map((value) => ({
  value,
  label: legalFormLabel(value),
}));

/** «ИНН 7707083893 · КПП 773601001»: только заданные части. */
export function formatTinKpp(
  tin: string | null | undefined,
  kpp: string | null | undefined,
  separator = ' · ',
): string {
  return [tin ? `ИНН ${tin}` : null, kpp ? `КПП ${kpp}` : null].filter(Boolean).join(separator);
}

const STATUS_LABELS: Record<LegalEntityStatus, string> = {
  [LegalEntityStatus.Active]: 'Действующая',
  [LegalEntityStatus.Liquidating]: 'Ликвидируется',
  [LegalEntityStatus.Liquidated]: 'Ликвидирована',
  [LegalEntityStatus.Bankrupt]: 'Банкротство',
  [LegalEntityStatus.Reorganizing]: 'Реорганизация',
};

export function legalEntityStatusLabel(status: LegalEntityStatus): string {
  return STATUS_LABELS[status];
}
